export default __webpack_public_path__ + "static/media/metaverseBG.494d822b.jpg";